/*
 * @Description: 积分商城库存管理相关接口
 * @Author: guqiang
 * @Date: 2021-10-13 17:41:43
 * @LastEditors: guqiang
 * @LastEditTime: 2021-10-13 18:09:47
 */
import request from './request';

/**
 * @description: 获取库存列表
 * @param {*} params http://yapi.iklicen.com/project/139/interface/api/436173
 * @return {*}
 */
export function getInventorys(params) {
    return request('/mall/inventory/list', {
        method: 'POST',
        params,
    });
}

export function getGoodsCategory(params) {
    return request('/mall/goods-category/tree', {
        method: 'GET',
        params,
    });
}
